module.exports = __webpack_public_path__ + "img/phoneBox.59476fba.svg";